import Vue from 'vue';
import VueRouter from 'vue-router';
import { Dialog } from 'vant';
import i18n from '@/i18n';
import UserAgreements from './UserAgreements.vue';

class AgreementService {
  /**
   * @type {Vue|null}
   */
  instance = null;

  hasAgree = false;

  confirm = () => {};

  constructor() {
    Vue.use(Dialog);
    Vue.use(VueRouter);
    const DialogConstructor = Vue.component('user-agreements', UserAgreements);
    const element = document.createElement('div');
    this.instance = new DialogConstructor({ i18n }).$mount(element);
    document.body.appendChild(element);
    this.instance.$on('confirm', () => {
      this.hasAgree = true;
      this.confirm();
    });
  }

  /**
   * @param {string} countryCode
   * @param {Function} confirm
   */
  open({ countryCode, confirm }) {
    if (this.hasAgree) {
      confirm();
    } else {
      this.instance.open(countryCode);
      this.confirm = confirm;
    }
  }
}

const Agreement = new AgreementService();
export default Agreement;
